<template>
  <div class="loadingAnimation">
    <div class="lds-ellipsis">
      <div :style="{ background: color }"></div>
      <div :style="{ background: color }"></div>
      <div :style="{ background: color }"></div>
      <div :style="{ background: color }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingAnimation",
  props: {
    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>

<style scoped>
.loadingAnimation {
  display: flex;
  justify-content: center;
  align-items: center;
}

.lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 7px;
}

.lds-ellipsis div {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #000;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.lds-ellipsis div:nth-child(1) {
  left: 4px;
  animation: lds-ellipsis1 0.6s infinite;
}

.lds-ellipsis div:nth-child(2) {
  left: 4px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(3) {
  left: 16px;
  animation: lds-ellipsis2 0.6s infinite;
}

.lds-ellipsis div:nth-child(4) {
  left: 28px;
  animation: lds-ellipsis3 0.6s infinite;
}

@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}

@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(12px, 0);
  }
}
</style>
